module.exports = __webpack_public_path__ + "static/media/eng_d_2058.80aba2d9.vtt";